import React from 'react';

import { ExtendedReportList } from '@futrli/views/processors/reports/reportsList';
import { ListingPageRowActions } from '@futrli/ui-components/components/listing-page/listing-page-row/listing-page-row-actions/listing-page-row-actions';

import { ReportDialogType } from './my-reports-tab';
import { useReportActionItems } from './hooks/use-report-action-items';

interface ReportActionsPopoverProps {
  report: ExtendedReportList;
  onDialogAction: (type: ReportDialogType, report: ExtendedReportList) => void;
}

export const ReportActionsPopover = ({ report, onDialogAction }: ReportActionsPopoverProps) => {
  const items = useReportActionItems({
    report,
    onLockUnlock: () => onDialogAction('lock', report),
    onPublishUnpublish: () => onDialogAction('publish', report),
    onDelete: () => onDialogAction('delete', report)
  });

  return <ListingPageRowActions items={items} />;
};
